var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.margin,attrs:{"cols":"12"}},[_c('v-switch',{staticClass:"switchglya",attrs:{"color":_vm.color,"label":_vm.checkBox == false || _vm.checkBox == undefined ? _vm.negative : _vm.positive},on:{"change":_vm.updateValue},model:{value:(_vm.checkBox),callback:function ($$v) {_vm.checkBox=$$v},expression:"checkBox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }